import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { UPDATE_PASSWORD_PARAMS } from './actionTypes';
import { updatePasswordDone, updatePasswordError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* updatePasswordCall(constAccessParams, action) {
    const { oldPassword, newPassword } = action.data;
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.setNewPass, newAccessParams, oldPassword, newPassword);
    if (isSuccessResponse(result)) {
        yield put(updatePasswordDone());
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(updatePasswordError(result));
    }
}
export function* watchUpdatePasswordCall(constAccessParams) {
    yield takeLatest(UPDATE_PASSWORD_PARAMS, updatePasswordCall, constAccessParams);
}
//# sourceMappingURL=saga.js.map